<template>
    <section class='viewsrhqyBaseManagecomponents_goodsTypeModal'>
        <el-dialog :title="title" :visible.sync="visible" width="680px" @close="onResetForm">
            <div class="pr-20">
                <el-form ref="form" :model="form" label-width="120px" :rules="rules">
                    <el-form-item label="基地" required>
                        {{ baseInfo.com_name }}
                    </el-form-item>
                    <!-- <el-form-item label="预约业务" prop="business_id">
                        <tableSelector @change="onBusinessChange" :multiple="false" title="选择预约业务" v-model="form.business_id"
                            :rows.sync="form.business" url="/api/queue/admin/query_business" :params="{
                                is_parent: 0,
                                state: 1,
                                keyword: ''
                            }" :columns="businessColumns">
                            <template slot="content">
                                <div>
                                    <div v-for="item in form.business" :key="item.id">{{ item.name }}</div>
                                </div>
                            </template>
                            <el-link type="primary" :underline="false">选择业务类型</el-link>
                        </tableSelector>
                    </el-form-item> -->
                    <el-form-item label="车辆业务类型" prop="car_business_id">
                        <tableSelector :multiple="false" title="选择车辆业务类型" v-model="form.car_business_id"
                            :rows.sync="form.car_business" url="/api/queue/admin/query_business" :params="{
                                is_parent: 1,
                                state: 1,
                                keyword: ''
                            }" :columns="carBusinessColumns">
                            <template slot="content">
                                <div>
                                    <div v-for="item in form.car_business" :key="item.id">{{ item.name }}</div>
                                </div>
                            </template>
                            <el-link type="primary" :underline="false">选择业务类型</el-link>
                        </tableSelector>
                    </el-form-item>
                    <el-form-item label="货物种类" prop="name">
                        <el-input v-model.trim="form.name" :maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <el-input type="textarea" :maxlength="50" :autosize="{ minRows: 2, maxRows: 4 }"
                            v-model="form.remark"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="visible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="onOk">确 定</el-button>
            </span>
        </el-dialog>
    </section>
</template>
<script>
import tableSelector from '@/components/tableSelector/index.vue';
import { cloneDeep } from 'lodash';
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            visible: false,
            baseList: [],
            form: {
                // business_id: [],
                car_business_id: [],
                name: "",
                remark: "",
                business: [],
                car_business: []
            },
            businessColumns: [
                { label: '预约业务名称', prop: 'name' },
                {
                    label: '业务类型',
                    prop: 'type',
                    formatData: (row) => {
                        return row.type == 11 ? "送货业务" : row.type == 12 ? "提货业务" : "--"
                    }
                }
            ],
            carBusinessColumns: [
                { label: '车辆代码', prop: 'code' },
                { label: '车辆预约业务类型', prop: 'name' }
            ],
            rules: {
                // business_id: [
                //     { required: true, message: '请选择预约业务', trigger: 'change' }
                // ],
                car_business_id: [
                    { required: true, message: '请选择车辆业务类型', trigger: 'change' }
                ],
                name: [
                    { required: true, message: '请输入货物种类', trigger: 'blur' }
                ]
            }
        };
    },
    components: {
        tableSelector
    },
    computed: {
        ...mapGetters([
            "baseInfo",
        ]),
        title() {
            return this.form.id ? "修改货物种类" : "新建货物种类";
        }
    },
    methods: {
        openModal(row) {
            this.visible = true;
            this.$nextTick(() => {
                if (row) {
                    let newData = {};
                    Object.keys(row).map((key) => {
                        if (Array.isArray(row[key]) && row[key].length === 0) {
                            newData[key] = ""
                        } else {
                            // if (key === "business_id") {
                            //     newData["business"] = [{ id: row[key], name: row.business_name }];
                            //     newData[key] = [row[key]];
                            // } else 
                            if (key === "car_business_id") {
                                newData["car_business"] = [{ id: row[key], name: row.car_business_name }];
                                newData[key] = [row[key]];
                            } else {
                                newData[key] = row[key]
                            }
                        }
                    })
                    this.form = Object.assign(this.form, cloneDeep(newData));
                    console.log(this.form);
                    
                }
            });
        },
        onOk() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const {
                        business,
                        car_business,
                        ...params
                    } = this.form;
                    const url = this.form.id ? "/api/queue/admin/update_goods_type" : "/api/queue/admin/create_goods_type";
                    this.$common.http({
                        url,
                        data: {
                            ...params,
                            // business_id: String(params.business_id),
                            car_business_id: String(params.car_business_id)
                        }
                    }).then(() => {
                        this.$message.success(`${this.form.id ? "修改" : "添加"}成功`);
                        this.visible = false;
                        this.$emit("ok");
                    })
                }
            })
        },
        onResetForm() {
            Object.keys(this.form).map((key) => {
                this.$set(this.form, key, null)
            })
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
        onBusinessChange() {
            this.form.car_business = [];
            this.form.car_business_id = [];
        }
    }
}

</script>